import React from 'react';

import PropTypes from 'prop-types';

const NavigationButton = (props) => {
  const {
    id,
    navigate,
    onClick,
    disabled,
    type,
  } = props.button;
  return (
    <button id={id} className={`navigationButton ${type}`} disabled={disabled} onClick={onClick} >
      {navigate}
    </button>
  );
};

export default NavigationButton;

NavigationButton.propTypes = {
  button: PropTypes.shape({
    navigate: PropTypes.string,
    disabled: PropTypes.bool,
  }).isRequired,
};
